import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class LimitDateValidator {
  static rangeLimit(maxMonths: number): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const startControl = group.get('dataDe');
      const endControl = group.get('dataAte');

      if (!startControl || !endControl) return null;

      const start = startControl.value;
      const end = endControl.value;

      if (!start || !end) {
        return null;
      }

      const startDate = new Date(start);
      const endDate = new Date(end);

      if (startDate > endDate) {
        endControl.setErrors({ ...endControl.errors, dataInvalida: true });
        return { dataInvalida: true };
      }

      // Validação 2: Diferença maior que X meses
      // Cálculo preciso baseando-se no ano e mês civil
      const startYear = startDate.getFullYear();
      const startMonth = startDate.getMonth();
      const endYear = endDate.getFullYear();
      const endMonth = endDate.getMonth();
      
      const diffMonths = (endYear - startYear) * 12 + (endMonth - startMonth);
      
      // Adiciona uma verificação extra pros dias (para não permitir p. ex. 01/Jan a 05/Mar como sendo = 2 meses se passar dos dias exatos no final)
      const isDayAfter = endDate.getDate() > startDate.getDate();
      const totalMonthsExact = isDayAfter ? diffMonths + 1 : diffMonths;

      if (totalMonthsExact > maxMonths) {
        // Define erro no controle 'dataAte'
        endControl.setErrors({ ...endControl.errors, intervaloExcedido: true });
        return { intervaloExcedido: true };
      }

      // Se passar, precisamos limpar esses erros específicos caso tenham sido setados anteriormente
      // (Mas mantemos outros erros como 'required' se existirem)
      if (endControl.hasError('dataInvalida')) {
        delete endControl.errors!['dataInvalida'];
        if (Object.keys(endControl.errors!).length === 0) endControl.setErrors(null);
      }
      if (endControl.hasError('intervaloExcedido')) {
        delete endControl.errors!['intervaloExcedido'];
        if (Object.keys(endControl.errors!).length === 0) endControl.setErrors(null);
      }

      return null;
    };
  }
}